module.exports = __webpack_public_path__ + "static/media/icon-circle_tick.5e9d2471.svg";